import * as CategoriesConstants from '../constants/categoryConstants';

const initialState = {
    categories: [],
    subCategoriesFilters: {},
    objects: [],
};

export default function categories(state = initialState, action) {

    switch (action.type) {
        case CategoriesConstants.GET_CATEGORIES_SUCCESS:
            return { ...state, categories: action.categories ? action.categories : state.categories };
        case CategoriesConstants.GET_SUBCATEGORY_FILTERS:
            return { ...state, subCategoriesFilters: action.subCategoriesFilters ? action.subCategoriesFilters : state.subCategoriesFilters };
        case CategoriesConstants.GET_OBJECTS:
            return { ...state, objects: action.objects ? action.objects : state.objects };
        default:
            return state;
    }
}